import { useCallback } from "react";
import { useWSSnackbar } from "@wingspanhq/fe-component-library";
import { downloadCSV as _downloadCSV } from "../../modules/Reports/utils/sheetjs/downloadCSV";
import { cleanCSVData } from "../utils/csv";
import isEmpty from "lodash/isEmpty";

export type UseDownloadCSVConfig = {
  cleanEmptyItems?: boolean;
  cleanEmptyColumns?: boolean;
};

export const useDownloadCSV = (config?: UseDownloadCSVConfig) => {
  const { openSnackbar } = useWSSnackbar();
  const { cleanEmptyItems = true, cleanEmptyColumns = true } = config || {};

  const downloadCSV = useCallback(
    async (data: object[], filename: string) => {
      try {
        let csvData = data;

        if (cleanEmptyItems) {
          csvData = csvData.filter(d => !isEmpty(d));
        }

        if (cleanEmptyColumns) {
          csvData = csvData.map(d => cleanCSVData(d, data));
        }

        _downloadCSV(csvData, filename);

        openSnackbar({
          type: "success",
          message: "CSV downloaded"
        });
      } catch (error) {
        console.error("Failed to download CSV", error);

        openSnackbar({
          type: "warning",
          message: "Failed to download CSV"
        });
      }
    },
    [openSnackbar, cleanEmptyItems, cleanEmptyColumns]
  );

  return {
    downloadCSV
  };
};
